export default {
    apiPrefix: 'electronic/pc/cms/',
    uploadSplitStr: '*##*',
}